<template>
    <div id="Application">
        <el-form
            :model="applyForm"
            ref="applyForm"
            label-width="150px"
            :label-position="isedit?'left':'right'"
        >
            <el-tabs
                class="main_tabs"
                v-model="activeName"
                type="card"
            >
                <el-tab-pane
                    :label="title"
                    :lazy="true"
                    name="reg"
                >
                    <el-row :gutter="30">
                        <el-col
                            :span="3"
                            style="text-align: center"
                            v-if="isedit"
                        >
                            <img
                                v-if="imageUrl"
                                :src="imageUrl"
                                class="avatar-uploader-icon"
                            />
                            <img
                                class="avatar-uploader-icon"
                                v-else
                                :src="defaultAvatar"
                                alt=""
                            >
                            <el-button
                                size="small"
                                type="primary"
                                icon="el-icon-edit"
                                class="edit-btn"
                                @click="edit"
                            >个人信息</el-button>
                        </el-col>
                        <el-col
                            :span="4"
                            style="text-align: center"
                            v-else
                        >
                            <el-tooltip
                                effect="dark"
                                content="点我切换图片"
                                placement="top"
                            >
                                <el-upload
                                    class="avatar-uploader"
                                    ref="upload"
                                    :action="fileUrl"
                                    :show-file-list="false"
                                    :auto-upload="false"
                                    :on-change="handleUpload"
                                    :on-success="handleAvatarSuccess"
                                    style="width: 100%"
                                >
                                    <img
                                        v-if="imageUrl"
                                        :src="imageUrl"
                                        class="avatar-uploader-icon edit"
                                    />
                                    <i
                                        v-else
                                        class="avatar-uploader-icon edit"
                                    ></i>
                                    <el-button
                                        type="primary"
                                        size="mini"
                                    >上传照片</el-button>
                                </el-upload>
                            </el-tooltip>

                        </el-col>
                        <el-col :span="20">
                            <el-col
                                :span="
                                    item.name == 'nowAddress' ||
                                    item.name == 'address'
                                        ? 16
                                        : 8
                                "
                                v-for="(item, index) in config"
                                :key="index"
                                style="position: relative"
                            >
                                <el-form-item
                                    :label="item.note + '：'"
                                    :prop="item.name"
                                    v-if="item.type == '2'"
                                    :class="item.mustFill ? 'is-required' : ''"
                                >
                                    <div v-if="
                                            item.name == 'phone' ||
                                            item.name == 'homeLinkManPhone' ||
                                            item.name == 'homeTel'
                                        ">
                                        <p v-if="isedit">
                                            {{ applyForm[item.name + "hide"] }}
                                        </p>
                                        <el-input
                                            v-else
                                            v-model.trim="
                                                applyForm[item.name + 'hide']
                                            "
                                            :placeholder="'请输入' + item.note"
                                            @focus="inputfoucus(item.name)"
                                            @change="inputchange(item.name)"
                                        ></el-input>
                                    </div>
                                    <div v-else-if="item.name == 'idCard'">
                                        <p v-if="isedit">
                                            {{ applyForm[item.name + "hide"] }}
                                        </p>
                                        <el-input
                                            v-else
                                            v-model.trim="
                                                applyForm[item.name + 'hide']
                                            "
                                            :placeholder="'请输入' + item.note"
                                            :disabled="true"
                                        ></el-input>
                                    </div>
                                    <div v-else-if="item.name == 'name'">
                                        <p v-if="isedit">
                                            {{ applyForm[item.name] }}
                                        </p>
                                        <el-input
                                            v-else
                                            v-model.trim="applyForm[item.name]"
                                            :placeholder="'请输入' + item.note"
                                            :disabled="true"
                                        ></el-input>
                                    </div>
                                    <div v-else-if="item.name == 'nowAddress'">
                                        <p v-if="isedit">
                                            {{ applyForm[item.name] }}
                                        </p>
                                        <div v-else>
                                            <el-col
                                                :span="14"
                                                class="el-14"
                                            >
                                                <el-cascader
                                                    :options="address"
                                                    v-model="
                                                        applyForm.nowAddress
                                                    "
                                                    clearable
                                                ></el-cascader>
                                            </el-col>
                                            <el-col
                                                :span="10"
                                                class="el-10"
                                            >
                                                <el-input
                                                    v-model="naddress"
                                                    size="medium"
                                                    placeholder="详细地址"
                                                ></el-input>
                                            </el-col>
                                        </div>
                                    </div>
                                    <div v-else-if="item.name == 'address'">
                                        <p v-if="isedit">
                                            {{ applyForm[item.name] }}
                                        </p>
                                        <div v-else>
                                            <el-col
                                                :span="14"
                                                class="el-14"
                                            >
                                                <el-cascader
                                                    :options="address"
                                                    v-model="applyForm.address"
                                                    clearable
                                                ></el-cascader>
                                            </el-col>
                                            <el-col
                                                :span="10"
                                                class="el-10"
                                            >
                                                <el-input
                                                    v-model="faddress"
                                                    size="medium"
                                                    placeholder="详细地址"
                                                ></el-input>
                                            </el-col>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <p v-if="isedit">
                                            {{ applyForm[item.name] }}
                                        </p>
                                        <el-input
                                            v-else
                                            v-model.trim="applyForm[item.name]"
                                            clearable
                                            :placeholder="'请输入' + item.note"
                                        ></el-input>
                                    </div>
                                </el-form-item>

                                <el-form-item
                                    :label="item.note + '：'"
                                    :prop="item.name"
                                    v-if="item.type == '3'"
                                    width="150px"
                                    :class="item.mustFill ? 'is-required' : ''"
                                >
                                    <p v-if="isedit">
                                        {{ applyForm[item.name] }}
                                    </p>
                                    <el-date-picker
                                        v-else
                                        v-model="applyForm[item.name]"
                                        type="date"
                                        :placeholder="'请输入' + item.note"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        clearable
                                        :editable="false"
                                        :picker-options="pickerOptions1"
                                    ></el-date-picker>
                                </el-form-item>
                                <el-form-item
                                    :label="item.note + '：'"
                                    :prop="item.name"
                                    v-if="item.type == '1'"
                                    :class="item.mustFill ? 'is-required' : ''"
                                >
                                    <p v-if="isedit">
                                        {{
                                            gettext(
                                                applyForm[item.name],
                                                item.code
                                            )
                                        }}
                                    </p>
                                    <el-select
                                        v-else
                                        v-model="applyForm[item.name]"
                                        clearable
                                        filterable
                                        :placeholder="'请输入' + item.note"
                                    >
                                        <el-option
                                            v-for="item in dictionary[
                                                item.code
                                            ]"
                                            :key="item.codeKey"
                                            :label="item.codeValue"
                                            :value="item.codeKey"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </el-form>
        <el-row
            type="flex"
            justify="center"
            v-if="!isedit"
        >
            <el-button
                type="primary"
                @click="submitForm"
                size="medium"
                style="padding: 15px 60px"
            >确认</el-button>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "PersonalInfo",
    data () {
        let bankRule = (rule, value, callback) => {
            if (value) {
                let flag = false;
                for (let i = 0; i < bankcardList.length; i++) {
                    for (let j = 0; j < bankcardList[i].patterns.length; j++) {
                        if (
                            new RegExp(bankcardList[i].patterns[j].reg).test(
                                value
                            )
                        ) {
                            flag = true;
                        }
                    }
                }
                if (!flag) {
                    callback(new Error("请输入正确的银行卡号"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        let checkMobile = (rule, value, callback) => {
            if (value) {
                const reg = /^1[34578]\d{9}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error("请输入正确的手机号"));
                }
            } else {
                callback();
            }
        };
        return {
            address: require("./address.json"),
            naddress: null,
            faddress: null,
            config: [],
            isedit: false,
            title: "学员资料",
            activeName: "reg",
            chargeflag: false,
            activeCollapse: false,
            imageUrl: "",
            fileUrl: this.$global.fileurl,
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            applyForm: {
                photourl: "",
                name: "",
            },
            phone: "",
            idcard: "",
            dictionary: {},
            options: [
                {
                    value: true,
                    label: "是",
                },
                {
                    value: false,
                    label: "否",
                },
            ],
            nativeData: [],
            //  设置出生日期不能大于当前时间
            pickerOptions1: {
                disabledDate: (time) => {
                    let me = this;
                    return time.getTime() > Date.now();
                },
            },
            getRowKey (row) {
                return row.id;
            },
            defaultAvatar: require("@/assets/images/icon/default-avatar.png"),
        };
    },
    async mounted () {
        let me = this;
        if (this.$route.query) {
            if (this.$route.query.param == "1") {
                this.isedit = true;
                this.title = "学员资料";
            }
        }
        await me.queryConfig();
        // me.queryCodeInfoByCode();
    },
    methods: {
        gettext (id, code) {
            let res = "";
            if (this.dictionary[code]) {
                let obj = this.dictionary[code].find((item) => {
                    return item.codeKey == id;
                });
                if (obj != undefined) {
                    res = obj.codeValue;
                }
                return res;
            }
        },
        inputfoucus (index) {
            this.applyForm[index + "hide"] = this.applyForm[index];
        },
        inputchange (index) {
            this.applyForm[index] = this.applyForm[index + "hide"];
        },
        edit () {
            this.isedit = false;
            let me = this;
            this.title = "编辑学员资料";
            if (me.applyForm.nowAddress) {
                me.applyForm.nowAddress = me.applyForm.nowAddress.split("-");
                me.naddress =
                    me.applyForm.nowAddress[me.applyForm.nowAddress.length - 1];
                me.applyForm.nowAddress = me.applyForm.nowAddress[0].split("/");
            }
            if (me.applyForm.address) {
                me.applyForm.address = me.applyForm.address.split("-");
                me.faddress =
                    me.applyForm.address[me.applyForm.address.length - 1];
                me.applyForm.address = me.applyForm.address[0].split("/");
            }
        },
        hidden: function (str, frontLen, endLen) {
            var len = str.length - frontLen - endLen;
            var xing = "";
            for (var i = 0; i < len; i++) {
                xing += "*";
            }
            return (
                str.substring(0, frontLen) +
                xing +
                str.substring(str.length - endLen)
            );
        },
        async queryStudentById () {
            let me = this,
                param = {
                    id: "",
                };
            me.applyForm = {};
            let userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(userinfo);
            param.id = userinfo.id;
            let res = await me.$team.queryStudentById(param);
            if (res && res["success"]) {
                let userinfo = res.content;
                window.sessionStorage.setItem(
                    "userinfo",
                    JSON.stringify(userinfo)
                );
                me.config.forEach(function (item, index) {
                    if (
                        item.name == "phone" ||
                        item.name == "homeLinkManPhone" ||
                        item.name == "homeTel" ||
                        item.name == "idCard"
                    ) {
                        item.hidden = item.name + "hide";
                        if (res.content[item.name]) {
                            let str = me.hidden(res.content[item.name], 3, 4);
                            me.$set(me.applyForm, item.hidden, str);
                        } else {
                            let str = "";
                            me.$set(me.applyForm, item.hidden, str);
                        }
                    }
                    if (item.type == "1") {
                        item.values = item.name + "code";
                        me.queryCodeInfoByCode(item.code);
                        me.applyForm[item.values] = "";
                    }
                    if (
                        item.name == "address" &&
                        res.content[item.name] &&
                        !me.isedit
                    ) {
                        res.content[item.name] =
                            res.content[item.name].split("-");
                        me.faddress =
                            res.content[item.name][
                            res.content[item.name].length - 1
                            ];
                        res.content[item.name] =
                            res.content[item.name][0].split("/");
                    }
                    if (
                        item.name == "nowAddress" &&
                        res.content[item.name] &&
                        !me.isedit
                    ) {
                        res.content[item.name] =
                            res.content[item.name].split("-");
                        me.naddress =
                            res.content[item.name][
                            res.content[item.name].length - 1
                            ];
                        res.content[item.name] =
                            res.content[item.name][0].split("/");
                    }
                    me.imageUrl = res.content.photoImg;
                    me.$set(me.applyForm, item.name, res.content[item.name]);
                });
            }
        },
        //  根据类型查询字典码
        async queryCodeInfoByCode (code) {
            let me = this;
            //  查询学员信息
            let param = {
                pageIndex: 1,
                pageSize: 10,
            };
            if (code == "nation") {
                let nation = await me.$userService.queryAll();
                if (nation && nation.success) {
                    let key = code;
                    me.$set(me.dictionary, key, nation.content.records);
                    // me.dictionary[key]= nation.content.records;
                }
            } else {
                let sex = await me.$userService.queryCodeInfoByCode(code);
                if (sex && sex.success) {
                    let key = code;
                    me.$set(me.dictionary, key, sex.content.records);
                    // me.dictionary[key]= sex.content.records;
                }
            }
        },
        async queryConfig () {
            let me = this,
                param = {
                    name: "",
                    pageIndex: 1,
                    pageSize: 999,
                };
            let res = await me.$team.queryConfig(param);
            if (res && res["success"]) {
                me.config = res.content.records;
                await me.queryStudentById();
            }
        },
        //  提交报名表单
        async submitForm () {
            let me = this,
                can = false;
            for (let i = 0; i < this.config.length; i++) {
                if (this.config[i].mustFill) {
                    let text = this.config[i].note;

                    if (me.applyForm[me.config[i].name] == "") {
                        me.$message({
                            message: "请填写报名学员" + text,
                            type: "error",
                        });
                        return;
                    }
                }

                if (i == me.config.length - 1) {
                    can = true;
                }
            }
            if (can) {
                if (
                    me.applyForm.phone &&
                    /^1[34578]\d{9}$/.test(me.applyForm.phone) === false
                ) {
                    me.$message({
                        showClose: true,
                        message: "请填写正确手机号码",
                        type: "error",
                    });
                    return;
                }
                if (
                    me.applyForm.homeLinkManPhone &&
                    /^1[34578]\d{9}$/.test(me.applyForm.homeLinkManPhone) ===
                    false
                ) {
                    me.$message({
                        showClose: true,
                        message: "请填写正确的家庭联系人手机号码",
                        type: "error",
                    });
                    return;
                }
                //  if (me.applyForm.homeTel&&/^1[34578]\d{9}$/.test(me.applyForm.homeTel) === false) {
                //     me.$message({
                //       showClose: true,
                //       message: "请填写正确的家庭联系人手机号码",
                //       type: "error"
                //     });
                //     return;
                //   }
                if (
                    me.applyForm.nowAddress &&
                    me.applyForm.nowAddress.length > 0
                ) {
                    me.applyForm.nowAddress = me.applyForm.nowAddress.join("/");
                    me.applyForm.nowAddress += "-";
                    me.applyForm.nowAddress += me.naddress;
                }
                if (me.applyForm.address && me.applyForm.address.length > 0) {
                    me.applyForm.address = me.applyForm.address.join("/");
                    me.applyForm.address += "-";
                    me.applyForm.address += me.faddress;
                }
                let res = await me.$userService.saveOrUpdateStudent(
                    me.applyForm
                );
                if (res && res.success) {
                    window.sessionStorage.setItem("isAllFlag", true);
                    me.$message({
                        message: "保存成功",
                        type: "success",
                    });
                    me.$store.commit("SET_SHOWLEFTSTATUS", true);
                    me.$router.replace({ name: "hello" });
                }
            }
        },
        //  清空报名表单
        resetForm () {
            let me = this;
            me.$confirm("是否清空当前入学报名信息?", "清空入学报名", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    me.$refs.applyForm.resetFields();
                })
                .catch(() => { });
        },

        //  点击上传图片
        submitUpload () {
            let me = this;
            if (!me.imageUrl || me.imageUrl === "") {
                me.$message({ message: "请选择图片", type: "error" });
                return;
            }
            me.$refs.upload.submit();
        },
        //  上传头像图片成功
        handleAvatarSuccess (response, file, fileList) {
            let me = this;
            if (response.success) {
                me.$message({
                    message: "上传图片成功",
                    type: "success",
                });
                me.applyForm.photoImg = response.content[0];
            } else {
                me.$message({
                    message: "网络错误,上传图片失败",
                    type: "success",
                });
            }
        },
        //  切换图片
        handleUpload (file, fileList) {
            let me = this;
            me.imageUrl = "";
            if (
                file.raw.type != "image/jpeg" &&
                file.raw.type != "image/png" &&
                file.raw.type != "image/gif"
            ) {
                me.$message({
                    message: "只能上传JPG/PNG/GIF图片！",
                    type: "error",
                });
            } else if (file.raw.size > me.$global.imageMaxSize) {
                me.$message({
                    message: "上传图片不能超过" + me.$global.imageMaxSizeText,
                    type: "error",
                });
            } else {
                me.$refs.upload.submit();
                me.imageUrl = URL.createObjectURL(file.raw);
            }
        },
    },
};
</script>
<style lang="scss">
#app {
    background-color: #eff2fa;
}
#Application {
    background-color: #fff;
    padding-bottom: 20px;
    .el-col-14 {
        padding: 0px !important;
    }
    .el-col-10 {
        padding-right: 0px !important;
    }
    .el-date-editor.el-input {
        width: auto;
    }
    .el-form-item {
        position: relative;
    }
    p {
        font-size: 16px;
    }
    .el-form-item__label {
        font-size: 16px;
    }
    .avatar-uploader-icon {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        font-size: 28px;
        color: #8c939d;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 15px;
    }
    .avatar-uploader-icon.edit {
        border-radius: initial !important;
        background-color: #f7f8fc;
    }
    .edit-btn {
        padding: 5px 4px;
        color: #539ac9;
        border-color: #539ac9;
        background-color: initial;
    }
    .el-col {
        margin-bottom: 5px;
    }
    .el-select,
    .el-cascader,
    .el-date-editor {
        width: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/user/personalInfo.vue